(function () {
  function mount(root) {
    if (!root || root.dataset.mountedTabs === "true") return;
    root.dataset.mountedTabs = "true";

    var buttons = Array.prototype.slice.call(root.querySelectorAll("[data-ms-tab]"));
    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-ms-card]"));
    var viewLink = root.querySelector("[data-ms-view-link]");

    function setActive(category) {
      buttons.forEach(function (button) {
        button.classList.toggle("is-active", button.dataset.msTab === category);
        button.setAttribute("aria-pressed", String(button.dataset.msTab === category));
      });
      cards.forEach(function (card) {
        card.classList.toggle("is-hidden", category !== "all" && card.dataset.msCard !== category);
      });
      if (viewLink) {
        var activeButton = buttons.find(function (button) {
          return button.dataset.msTab === category;
        });
        var nextUrl = activeButton ? activeButton.getAttribute("data-ms-tab-link") : "";
        if (!nextUrl) nextUrl = viewLink.getAttribute("data-" + category + "-link");
        if (nextUrl) viewLink.setAttribute("href", nextUrl);
      }
      var row = root.querySelector(".ms-product-row");
      if (row) row.scrollLeft = 0;
    }

    var initialButton = buttons.find(function (button) { return button.classList.contains("is-active"); }) || buttons[0];
    if (initialButton) setActive(initialButton.dataset.msTab);

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        setActive(button.dataset.msTab);
      });
    });
  }

  function mountAll() {
    document.querySelectorAll("[data-ms-product-tabs]").forEach(mount);
  }

  document.addEventListener("DOMContentLoaded", mountAll);
  document.addEventListener("shopify:section:load", function (event) {
    event.target.querySelectorAll("[data-ms-product-tabs]").forEach(mount);
  });
})();
